export const buildOptionSelectionLabel = (optionSelections = []) => {
  if (!optionSelections.length) return "";
  return optionSelections
    .map((selection) => `${selection.groupName}: ${selection.valueLabel}`)
    .join(", ");
};

export const buildVariantKey = (ticketId, optionSelections = []) => {
  const selectionKey = optionSelections
    .map((selection) => `${selection.groupId}:${selection.valueId}`)
    .sort()
    .join("|");
  return `${ticketId}::${selectionKey || "base"}`;
};

export const getOptionPriceDelta = (optionSelections = []) =>
  optionSelections.reduce((sum, selection) => sum + Number(selection.priceDelta || 0), 0);

export const getRemainingOptionStock = (ticket, groupId, valueId, selectedTickets = []) => {
  const group = (ticket.options || []).find((optionGroup) => optionGroup.id === groupId);
  const value = group?.values?.find((optionValue) => optionValue.id === valueId);
  if (!value || value.stock === null || value.stock === undefined) return null;

  const cartReserved = selectedTickets.reduce((total, selectedTicket) => {
    const usesOption = (selectedTicket.optionSelections || []).some(
      (selection) => selection.groupId === groupId && selection.valueId === valueId,
    );
    return usesOption ? total + Number(selectedTicket.number || 0) : total;
  }, 0);

  return Number(value.stock) - Number(value.amountSold || 0) - Number(value.pendingCheckoutQuantity || 0) - cartReserved;
};
